const DanoneCalc = () => import('../components/danone/DanoneCalc');
document.querySelectorAll('.danone-calc-js').forEach(danoneBlock => {
  new Vue({
    el: danoneBlock,
    template: `<DanoneCalc :danone-programs='` + JSON.stringify(window.danonePrograms) + `'/>`,
    components: {DanoneCalc},
  });
});

